import { Injectable, signal } from '@angular/core';
import { SpinnerState } from '../interfaces/spinner-state.interface';
import { SpinnerMode } from '../enums/spinner-mode.enum';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private pendingRequests = 0;
  public state = signal<SpinnerState>({ show: false });

  showSpinner(spinnerMode: SpinnerMode) {
    this.pendingRequests++;
    this.state.set({
      mode: spinnerMode,
      show: true,
    });
  }

  hideSpinner() {
    this.pendingRequests--;
    if (this.pendingRequests < 0) {
      this.pendingRequests = 0;
    }
    if (this.pendingRequests === 0) {
      this.state.set({
        mode: undefined,
        show: false,
      });
    }
  }
}
